class NewResumeSearches {
  constructor() {
    // Currency id 1 is 'JPY' and this value does not change
    this.defaultCurrencyId     = 1
    this.keyResumeSearchResult = `resume_search_results:${gon.resume_search_result_id}:close`
  }

  ready() {
    const newResumeSearches = this

    $(document).ready(function () {
      let resumeSearchResult = sessionStorage.getItem(newResumeSearches.keyResumeSearchResult)
      let pagePaths = window.location.pathname.split('/')

      if (!resumeSearchResult) {
        $('div.display-sidebar-form-fixed-top .hide-button.active').removeClass('active')
        $('div.display-sidebar-form-fixed-top .show-sidebar-button').addClass('active')
        $('div.new-resume-search-form-sidebar').removeClass('d-none')
      }

      $('.new-resume-search .modal').on('hidden.bs.modal', function () {
        $(this).find('.js-custom-checkbox :checkbox').prop('checked', false)
        $(this).find('.collapse').collapse('hide')
        $(this).find('.js-wrap-location').empty()
      })

      if (window.location.search.includes('new_search_saved=true')) {
        $('div.alert-saved-search-condition').removeClass('d-none')
      }

      if (pagePaths.includes('resume_searches') && (pagePaths.includes('new') || pagePaths.includes('edit') || pagePaths.includes('delete'))) {
        $('footer').addClass('d-none')
      }

      $('.skill-cer-selection .card-body').on('show.bs.collapse', function () {
        let $cardHeader = $(this).siblings('.card-header')

        $cardHeader.find('a.custom-select').css({ background: '#0A97E6' })
        $cardHeader.find('i.arrow').removeClass('down').addClass('up')
      })

      $('.skill-cer-selection .card-body').on('hidden.bs.collapse', function () {
        let $cardHeader = $(this).siblings('.card-header')

        $cardHeader.find('a.custom-select').css({ background: '#354052' })
        $cardHeader.find('i.arrow').removeClass('up').addClass('down')
      })

      $('.skill-cer-selection .js-custom-checkbox :checkbox').on('click', function () {
        let value       = $(this).val()
        let isChecked   = $(this).prop('checked')
        let $cardBody   = $(this).closest('.card-body')
        let $cardHeader = $cardBody.siblings('.card-header')
        let $badge      = $cardHeader.find('span.badge')

        let checkedLength = $cardBody.find(':checkbox:checked').length
        if (checkedLength > 0) {
          $badge.removeClass('hide')
          $badge.text(checkedLength)
        } else {
          $badge.addClass('hide')
          $badge.text('')
        }

        let cardWrappers = $cardBody.parent('.card-wrapper').siblings('.card-wrapper')
        cardWrappers.each(function () {
          let $otherCardBody = $(this).find('.card-body')
          let $otherCheckBox = $otherCardBody.find(`:checkbox[value='${value}']`)

          if ($otherCheckBox.length === 0) return

          $otherCheckBox.prop('checked', isChecked)

          let $otherCardHeader   = $otherCardBody.siblings('.card-header')
          let $otherBadge        = $otherCardHeader.find('span.badge')
          let otherCheckedLength = $otherCardBody.find(':checkbox:checked').length
          if (otherCheckedLength > 0) {
            $otherBadge.removeClass('hide')
            $otherBadge.text(otherCheckedLength)
          } else {
            $otherBadge.addClass('hide')
            $otherBadge.text('')
          }
        })
      })
    })
  }

  setDisableLanguageLevel(target) {
    let changedValue   = $(target).val()
    let disabledTarget = $(target).parents('.js-form-other-language').find('.js-other-language-level')

    if (!changedValue) {
      disabledTarget.prop('disabled', true)
      disabledTarget.val('')
    } else {
      disabledTarget.prop('disabled', false)
    }
  }

  checkConditionBeforeSubmit(event, isOpenModalTitle = false) {
    event.preventDefault()

    let minAge = parseInt($('#search_min_age').val())
    let maxAge = parseInt($('#search_max_age').val())
    let title  = $('#resume-search-title').val()
    let isLimitedWorkExperienceCountry = $('#search_is_limited_work_experience_country').is(':checked')
    let inputLimitWorkExperienceCountry = parseInt($('.input-limit-work-experience-country').val()) || 0

    $('#search_title').val(title)

    if (isLimitedWorkExperienceCountry && inputLimitWorkExperienceCountry < 1) {
      alert(gon.views.shared.limit_work_experience_country)
    } else if (minAge && maxAge && minAge > maxAge) {
      alert(gon.views.shared.min_age_must_be_less_than_max_age)
    } else if (isOpenModalTitle) {
      $('#modal-save-title').modal('show')
    } else {
      $('#resume-search-renew-form').submit()
      this.showIconLoading()
    }
  }

  saveSearchCondition(target) {
    let titleChange    = $('input#resume-search-title').val()
    let resumeSearchId = $(target).attr('data-id')

    if (titleChange.length > 64) {
      alert(gon.views.shared.maximum_length_64)
      return
    }

    if (titleChange.length === 0) return

    $('#search_title').val(titleChange)

    $('#modal-save-title').modal('hide')

    let baseUrl      = window.location.origin
    let isEnLanguage = window.location.href.split('/').includes('en')

    if (isEnLanguage) baseUrl += '/en'

    if (!resumeSearchId) {
      this.showIconLoading()
      let params = $('#resume-search-renew-form').serialize() + '&save_search=true'

      $.ajax({
        method: 'post',
        url: `${Routes.save_new_search_condition_resume_searches_path()}?${params}`,
        success: function(res) {
          if (res.status === 200) {
            window.location.replace(`${baseUrl}/resume_searches/${res.id}/edit?new_search_saved=true`)
          } else {
            console.log(res.errors)
          }
        },
        fail: function(error) { console.log(error) }
      })
    } else {
      let newResumeSearches = this
      let params            = $('#resume-search-renew-form').serialize() + '&save_search=true'
      newResumeSearches.showIconLoading()

      $.ajax({
        method: 'put',
        url: `${Routes.save_edit_search_condition_resume_search_path(resumeSearchId)}?${params}`,
        success: function(res) {
          if (res.status === 200) {
            if (res.new_search_saved) {
              let isEditPage = window.location.pathname.split('/').includes('edit')

              if (isEditPage) {
                window.location.replace(`${baseUrl}/resume_searches/${res.id}/edit?new_search_saved=true`)
              } else {
                window.location.replace(`${baseUrl}/resume_searches/${res.id}/resume_search_results/${res.resume_search_result_id}?searchid=${res.id}&new_search_saved=true`)
              }
            } else {
              $('div.alert-saved-search-condition').removeClass('d-none')
              newResumeSearches.hideIconLoading()
              if ($('div.new-resume-search-form-navbar').length > 0 || $('div.form-modal-render-area').length > 0) {
                $('div.new-resume-search-form-navbar, div.form-modal-render-area').animate({ scrollTop: 0 }, 400)
              } else {
                $('html, body').animate({ scrollTop: 0 }, 400)
              }
            }
          } else {
            console.log(res.errors)
            $('div.alert-saved-search-condition').addClass('d-none')
          }
        },
        fail: function(error) { console.log(error) }
      })
    }
  }

  openModalSelect(target) {
    let $this         = $(target)
    let $modal        = $($this.data('modal'))
    let $wrapLocation = $modal.find('.js-wrap-location').empty()
    let $template     = $this.parent().siblings($this.data('templateContent'))
    let $groups       = $this.parent().siblings($this.data('output')).find('div[id^="js-tsl"]')

    if ($groups.length) {
      $groups.each(function () {
        let $current_template = $(`<div class='js-location'>${$template.html()}</div>`)

        $wrapLocation.append($current_template)

        $(this).find('input').each(function (index) {
          let id = $(this).val()

          $($current_template.find('select').get(index)).val(id).change()
        })
      })
    } else {
      let $current_template = $(`<div class='js-location'>${$template.html()}</div>`)

      $wrapLocation.html($current_template)
    }

    if ($this.data('templateContent') == '#js-location-work-history-template') {
      this.onchange($wrapLocation.find('select').first())
    }

    $modal.modal('show')
  }

  onchange(target) {
    let $this         = $(target)
    let $wrapLocation = $this.closest('.modal').find('.js-wrap-location')
    let $selects      = $wrapLocation.find('select')
    let $allVals      = $selects.map(function() { return $(this).val() }).get()

    $selects.each(function() {
      let select      = $(this)
      let selectedVal = select.val()

      select.find('option').removeAttr('disabled')
      $allVals.forEach(function(val) {
        if (selectedVal != val && val != '') {
          select.find("option[value='" + val + "']").prop('disabled', true)
        }
      })
    })
  }

  addMoreLocation(target, idTemplate) {
    let $this         = $(target)
    let $template     = $(idTemplate).html()
    let $wrapLocation = $this.closest('.modal').find('.js-wrap-location')

    $wrapLocation.append(`<div class='js-location'>${$template}</div>`)
    if (idTemplate == '#js-location-work-history-template') {
      this.onchange($wrapLocation.find('select').first())
    }
  }

  onClickAgreeSelectLocation(target) {
    let $this         = $(target)
    let $output       = $($this.data('output'))
    let $modal        = $this.parents('.modal')
    let $locations    = $this.parent('.modal-footer').siblings('.modal-body').find('.js-location')
    let inputName     = $this.data('inputName')
    let inputSubnames = $this.data('inputSubname').split(',')
    let alreadyItems  = []

    $output.empty()
    $locations.each(function (index) {
      let ids  = []
      let text = []

      $(this).find('option:selected').each(function () {
        if (!this.value) return

        ids.push(this.value)
        text.push(this.text)
      })

      if (ids.length > 0 && !alreadyItems.includes(ids.toString())) {
        let html = ''

        ids.forEach(function (id, index) { html += `<input type='hidden' name='${inputName}[${inputSubnames[index]}]' value=${id}>` })
        html += `<span class='badge badge-pill badge-secondary'>${text.join(' / ')}</span>`
        html = `<div id='js-tsl-${Number(new Date()) + index}' class='badge-subgroup' onclick='NewResumeSearches.onClickRemoveBadgeOption(this)'>${html}</div>`
        $output.append(html)
        alreadyItems.push(ids.toString())
      }
    })

    $modal.modal('hide')
    $modal.find('.js-wrap-location').empty()
  }

  onClickAgreeSelectCountry(target) {
    let $this         = $(target)
    let $output       = $($this.data('output'))
    let $modal        = $this.parents('.modal')
    let $locations    = $this.parent('.modal-footer').siblings('.modal-body').find('.js-location')
    let inputName     = $this.data('inputName')
    let inputSubnames = $this.data('inputSubname').split(',')
    let alreadyItems  = []

    $output.empty()
    $locations.each(function (index) {
      let ids  = []
      let text = []

      $(this).find('option:selected').each(function () {
        if (!this.value) return

        ids.push(this.value)
        text.push(this.text)
      })

      if (ids.length > 0 && !alreadyItems.includes(ids.toString())) {
        let html = ''
        ids.forEach(function (id, index) { html += `<input type='hidden' name='${inputName}[${inputSubnames[index]}]' value=${id}>` })
        html += `<span class='badge badge-pill badge-secondary'>${text.join(' / ')}</span>`
        html = `<div id='js-tsl-${Number(new Date()) + index}' class='badge-subgroup' onclick='NewResumeSearches.onClickRemoveBadgeOption(this)'>${html}</div>`
        $output.append(html)
        alreadyItems.push(ids.toString())
      }
    })

    $modal.modal('hide')
    $modal.find('.js-wrap-location').empty()
  }

  updateCurrency(target, default_value = '') {
    let currency_options

    if(target.value === '') {
      currency_options = `<option value=${default_value}>----------</option>`
    } else {
      let currency_id     = parseInt(target.value).toString === target.value ? parseInt(target.value) : target.value
      const currency_list = gon.currency_list[currency_id].list

      currency_options = currency_list.map(function (ele) {
        if (!ele) {
          return `<option value=''>${gon.views.shared.please_choose}</option>`
        }
        return `<option value='${ele[1]}'>${ele[0]}</option>`
      })
    }

    $(target).parents('.salary-select--dependent').find('.salary-value').html(currency_options)
  }

  openModalCheckbox(target) {
    let $this   = $(target)
    let $modal  = $($this.data('modal'))
    let $output = $($this.data('output'))

    $modal.find(':checkbox').prop('checked', false)
    $output.find('input[type="hidden"]').each(function () {
      let $checkBox = $modal.find(`:checkbox[value='${this.value}']`)

      $checkBox.prop('checked', true)
      $checkBox.closest('.collapse').addClass('show')

      // For job types modal
      let groupParent = $checkBox.closest('.js-group-parent')
      let unCheck = $(groupParent).find('.js-custom-checkbox :checkbox:not(:checked)')
      if (unCheck.length === 0) {
        $(groupParent).siblings().find(':checkbox').prop('checked', true)
      }
    })

    $modal.modal('show')
  }

  openSkillCerModalCheckbox(target) {
    let $this   = $(target)
    let $modal  = $($this.data('modal'))
    let $output = $($this.data('output'))

    $modal.find(':checkbox').prop('checked', false)
    $modal.find('.collapse').removeClass('show')
    $modal.find('span.badge').addClass('hide').text('')
    $modal.find('a.custom-select').css({ background: '#354052' })
    $modal.find('i.arrow').removeClass('up').addClass('down')

    $output.find('input[type="hidden"]').each(function () {
      let checkboxes = $modal.find(`:checkbox[value='${this.value}']`)
      checkboxes.each(function () {
        let $checkBox   = $(this)
        let $cardBody   = $checkBox.closest('.collapse')
        let $cardHeader = $checkBox.closest('.collapse').siblings('.card-header')
        let $badge      = $cardHeader.find('span.badge')

        $checkBox.prop('checked', true)
        $checkBox.closest('.collapse').addClass('show')
        $cardHeader.find('a.custom-select').css({ background: '#0A97E6' })
        $cardHeader.find('i.arrow').removeClass('down').addClass('up')

        let checkedLength = $cardBody.find(':checkbox:checked').length
        if (checkedLength > 0) {
          $badge.removeClass('hide')
          $badge.text(checkedLength)
        } else {
          $badge.addClass('hide')
          $badge.text('')
        }
      })
    })

    $modal.modal('show')
  }

  onClickAgreeOptions(target) {
    let $this      = $(target)
    let $output    = $($this.data('output'))
    let $modal     = $this.parents('.modal')
    let checkboxes = $this.parent('.modal-footer').siblings('.modal-body').find(':checkbox:checked')
    let input_name = $this.data('inputName')

    $output.empty()
    checkboxes.each(function (index) {
      let $itself = $(this)
      let title   = $itself.data('title')
      let id      = $itself.val()
      let html    = ''
      if (title && id) {
        html += `<input type='hidden' name='${input_name}' value='${id}'>`
        html += `<span class='badge badge-pill badge-secondary' data-id='${id}'>${title}</span>`
        $output.append(`<div id='js-tsl-${Number(new Date()) + index}' class='badge-subgroup' onclick='NewResumeSearches.onClickRemoveBadgeOption(this)'>${html}</div>`)
      }
    })

    $modal.modal('hide')
  }

  onChoseJobtype(target, type, elId) {
    if (type === 'parent') {
      if ($(target).is(':checked')) {
        $(`#group-${elId}`).find('.js-custom-checkbox :checkbox').prop('checked', true)
      } else {
        $(`#group-${elId}`).find('.js-custom-checkbox :checkbox').prop('checked', false)
      }
    } else {
      if ($(target).is(':checked')) {
        let unCheck = $(`#group-${elId}`).find('.js-custom-checkbox :checkbox:not(:checked)')
        if (unCheck.length === 0) $(`#${elId}`).prop('checked', true)
      } else {
        $(`#${elId}`).prop('checked', false)
      }
    }
  }

  onClickAgreeSkillCerOptions(target) {
    let $this      = $(target)
    let $output    = $($this.data('output'))
    let $modal     = $this.parents('.modal')
    let checkboxes = $this.parent('.modal-footer').siblings('.modal-body').find(':checkbox:checked')
    let input_name = $this.data('inputName')

    checkboxes.each(function (index) {
      let checkboxVal   = $(this).val()
      let valIsSelected = false

      $output.children().each(function() {
        if ($(this).find('span').text().toLowerCase() === checkboxVal.toLocaleLowerCase()) {
          valIsSelected = true
          return
        }
      })

      if (!valIsSelected) {
        let html = ''

        html += `<input type='hidden' name='${input_name}' value='${checkboxVal}'>`
        html += `<div class='d-flex pl-0 col-sm-11 align-items-center'><span>${checkboxVal}</span></div>`
        html += `<div class='col-sm-0 d-flex align-items-center justify-content-center'><button class='btn p-0' onclick='NewResumeSearches.onClickRemoveChoseRow(this)' type='button'><i class='ct-wf ct-wf-trash'></i></button></div>`
        $output.append(`<div id='js-tsl-${Number(new Date()) + index}' class='chose-row d-flex'>${html}</div>`)
      }
    })

    $modal.modal('hide')
  }

  onClickRemoveBadgeOption(target) {
    let $this = $(target)

    $this.fadeOut(200, function () { $this.remove() })
  }

  onClickRemoveChoseRow(target) {
    let $this = $(target).closest('.chose-row')

    $this.fadeOut(200, function () { $this.remove() })
  }

  hideIconLoading() {
    $('div#page-loading').addClass('d-none')
  }

  showIconLoading() {
    $('div#page-loading').removeClass('d-none')
  }

  addInputItem(idInput, fieldName, output) {
    let $input  = $(idInput)

    if (!$input.val()) return

    // 255 is validate for input type string
    if ($input.val().length > 255) {
      alert(gon.views.shared.maximum_length_255)
      return
    }

    let $output      = $(output)
    let tagIsAlready = false
    $output.children().each(function() {
      if ($(this).text().toLowerCase() === $input.val().toLocaleLowerCase()) {
        tagIsAlready = true
        return
      }
    })
    if (tagIsAlready) {
      alert(gon.views.shared.search_condition_has_been_already)
    } else {
      let html = ''

      html += `<input type='hidden' name='${fieldName}' value='${$input.val()}'>`
      html += `<div class='d-flex pl-0 col-sm-11 align-items-center'><span>${$input.val()}</span></div>`
      html += `<div class='col-sm-0 d-flex align-items-center justify-content-center'><button class='btn p-0' onclick='NewResumeSearches.onClickRemoveChoseRow(this)' type='button'><i class='ct-wf ct-wf-trash'></i></button></div>`
      $output.append(`<div id='js-tsl-${Number(new Date())}' class='chose-row d-flex'>${html}</div>`)
      $input.val('')
    }
  }

  changeSavedSearchCondition(target) {
    let resumeSearchId = $(target).val()
    let baseUrl        = window.location.origin
    let isEnLanguage   = window.location.href.split('/').includes('en')

    if (isEnLanguage) baseUrl += '/en'

    this.showIconLoading()

    if (resumeSearchId) {
      window.location.replace(`${baseUrl}/resume_searches/${resumeSearchId}/edit`)
    } else {
      window.location.replace(`${baseUrl}/resume_searches/new`)
    }
  }

  closeSearchForm() {
    let formContent = this.loadFormContent()
    $('div.display-sidebar-form-fixed-top').find('.active').removeClass('active')
    $('div.display-sidebar-form-fixed-top .hide-button').addClass('active')
    $('div.new-resume-search-form-sidebar').addClass('d-none')
    $('div.new-resume-search-form-popup-full-screen').addClass('d-none')
    $('div.form-sidebar-render-area').html('')
    $('div.form-popup-full-screen-render-area').html('')
    $('div#form-content').html(formContent)
    sessionStorage.setItem(this.keyResumeSearchResult, true)
  }

  openSidebarSearchForm() {
    let formContent = this.loadFormContent()
    $('div.display-sidebar-form-fixed-top').find('.active').removeClass('active')
    $('div.display-sidebar-form-fixed-top .show-sidebar-button').addClass('active')
    $('div.new-resume-search-form-sidebar').removeClass('d-none')
    $('div.new-resume-search-form-popup-full-screen').addClass('d-none')
    $('div.form-sidebar-render-area').html(formContent)
    $('div.form-popup-full-screen-render-area').html('')
    $('div#form-content').html('')
    sessionStorage.removeItem(this.keyResumeSearchResult)
  }

  openSidebarFullSearchForm() {
    let formContent = this.loadFormContent()
    $('div.display-sidebar-form-fixed-top').find('.active').removeClass('active')
    $('div.display-sidebar-form-fixed-top .show-sidebar-full-button').addClass('active')
    $('div.new-resume-search-form-sidebar').addClass('d-none')
    $('div.new-resume-search-form-popup-full-screen').removeClass('d-none')
    $('div.form-popup-full-screen-render-area').html(formContent)
    $('div.form-sidebar-render-area').html('')
    $('div#form-content').html('')
    sessionStorage.removeItem(this.keyResumeSearchResult)
  }

  loadFormContent() {
    if ($('div.form-sidebar-render-area').children().length > 0) {
      return $('div.form-sidebar-render-area').children()
    } else if ($('div.form-popup-full-screen-render-area').children().length > 0) {
      return $('div.form-popup-full-screen-render-area').children()
    } else {
      return $('div#form-content').children()
    }
  }

  resetSearchForm() {
    if (confirm(gon.views.shared.confirm_clear_form)) {
      $('#resume-search-renew-form select').val('')
      $('#resume-search-renew-form input[type="text"]').val('')
      $('#resume-search-renew-form input[type="radio"]:checked').prop('checked', false)
      $('#resume-search-renew-form .badge-choosen').empty()
      $('#search_keywords_default_logic_or').prop('checked', true)
      $('#search_except_keywords_logic_and').prop('checked', true)
      $('#search_gender_both').prop('checked', true)
      $('#search-salary-foreign-salary-id').val($('#search-salary-foreign-salary-id option:first').val())
      $('#search-salary-foreign-max-salary').val($('#search-salary-foreign-max-salary option:last').val())
      $('#search_min_other_language1_level_id').prop('disabled', true)
      $('#search_min_other_language2_level_id').prop('disabled', true)
      $('#js-search-exclude input[type="checkbox"]').prop('checked', false)
      $('#js-search-education-level-flags input[type="checkbox"]').prop('checked', false)
      this.loadDefaultOptionCurrency('#search_salary_currency_id', '#search_min_salary', '#search_max_salary')
      this.loadDefaultOptionCurrency('#search_desired_salary_currency_id', '#search_desired_min_salary', '#search_desired_max_salary')
      $('input.input-limit-work-experience-country').val(1)
      $('#search_is_limited_work_experience_country').prop('checked', false)
    }
  }

  loadDefaultOptionCurrency(currencyIdEle, minSalaryIdEle, maxSalaryIdEle) {
    let currencyOptions = gon.currency_list[this.defaultCurrencyId].list
    let currencyOptionElements = currencyOptions.map(([name, id]) => `<option value='${id}'>${name}</option>`)
    $(currencyIdEle).val(this.defaultCurrencyId).change()
    $(minSalaryIdEle).html('')
    $(minSalaryIdEle).html(currencyOptionElements)
    $(maxSalaryIdEle).html('')
    $(maxSalaryIdEle).html(currencyOptionElements)
  }

  cancelSaveTitle() {
    $('#resume-search-title').val($('#search_title').val())
  }
}

export default new NewResumeSearches()
